import React from 'react';

import { di } from 'react-magnetic-di';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

import { FormFieldType } from '../../../../../../../common/types/form/form-fields';
import type { FormFieldComponentRenderer } from '../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../controllers/form-renderer-store';

const styles = cssMap({
	fieldContainerStyles: {
		paddingTop: token('space.050'),
	},
	fieldsetStyles: {
		margin: '0',
		padding: '0',
		paddingTop: token('space.050'),
		border: 'none',
		inlineSize: '100%',
	},
});

export const FieldContainer: FormFieldComponentRenderer = ({ children, fieldId }) => {
	di(useFormField);
	const formField = useFormField({ fieldId });

	const shouldUseFieldset =
		formField?.type === FormFieldType.CHECKBOX || formField?.type === FormFieldType.RADIO;
	if (shouldUseFieldset && fg('jsm-reqin-fieldset-update')) {
		return (
			<Box as="fieldset" testId="fieldset-container" xcss={styles.fieldsetStyles}>
				{children}
			</Box>
		);
	}
	return (
		<Box testId="field-container" xcss={styles.fieldContainerStyles}>
			{children}
		</Box>
	);
};
